module.exports = __webpack_public_path__ + "static/img/unlockNewLevel.3261952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/unlockNewLevel.png
// module id = HpM2
// module chunks = 1